
import Form from "./Form";

export default function AddAnswerSection({ discussion, onReloadNeeded }) {
	return (
		<div>
			<Form discussion={discussion} onSuccess={onReloadNeeded} />
		</div>
	)
}
